/**
 * Import Lib & assets
 */

import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

const Radio = styled.div`
  ${t.mixins.flex()}

  ${t.mixins.sm(`
    flex-wrap: wrap;
  `)}
`;
const Container = styled.div`
  padding: 0 22px;
  ${t.mixins.flex({ justify: "flex-start", direction: "column" })}
  margin: 9px 0;
  cursor: pointer;
`;
const Image = styled.img`
  margin-bottom: 25px;
  user-drag: none;

  ${t.mixins.sm(`
    max-width: 87px;
  `)}
`;
const Button = styled.button`
  min-height: 22px;
  min-width: 22px;
  border-radius: 50%;
  border: solid 1px ${t.color.darkGrey};
  cursor: pointer;
  flex: 2;

  ${t.mixins.sm(`
    min-height: 19px;
    min-width: 19px;
  `)}

  ${({ selected }) =>
    selected &&
    `
    background-color: ${t.color.secondary}
    border: none;

  `}
`;
const Label = styled.p`
  ${t.mixins.rem(18, 24)}
  margin-bottom: 16px;
  font-family: ${t.font.primary};
  color: ${t.color.darkGrey};
  cursor: pointer;

  ${t.mixins.sm(`
    ${t.mixins.rem(13, 15)}
  `)}
`;

/**
 * radio component is..
 */

const Form__radio__image = ({ answers, updateValue, filled = undefined }) => {
  const [selected, setSelected] = useState(filled);
  useEffect(() => {
    if (selected) {
      updateValue(selected);
    }
  }, [selected]);
  return (
    <Radio>
      {answers.map(answer => {
        const { title, id, img } = answer;
        const image = t.image[img];
        return (
          <Container key={id} onClick={() => setSelected(id)}>
            {image && <Image src={image} />}
            <Label>{title}</Label>
            <Button selected={selected === id} />
          </Container>
        );
      })}
    </Radio>
  );
};

export default Form__radio__image;

Form__radio__image.propTypes = {
  /**
      Function to trigger when new radio selected
      */
  updateValue: PropTypes.func.isRequired,
};
